import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { ButtonTheme, Key } from '@philips-internal/oswald-ui-constants';
import { REQUIRED } from '@philips-internal/oswald-ui-model/lib/validators/index.js';
import { Button } from '../../button/button.js';
import { Field } from '../../field/field.js';
import { Form } from '../../form/form.js';
import { InputMode } from '../../input/input-constants.js';
import { Input } from '../../input/input.js';
const requiredValidator = { name: REQUIRED };
const emptyFormData = {
    value: '',
};
const InfraredContent = forwardRef(function InfraredContent(props, handleRef) {
    const formRef = useRef(null);
    const [formData, setFormData] = useState(emptyFormData);
    const [validForm, setValidForm] = useState(undefined);
    useImperativeHandle(handleRef, () => ({
        reset: () => {
            setFormData(emptyFormData);
            setValidForm(undefined);
        },
    }));
    const onSubmitClick = () => {
        if (!validForm) {
            return;
        }
        props.onSubmitButtonClick({
            value: formData.value,
        });
    };
    const onFormChange = (event) => {
        setFormData(event.value);
    };
    const onFormValidate = (event) => {
        setValidForm(event.valid);
    };
    const onInputFieldKeydown = (event) => {
        if (event.key !== Key.ENTER) {
            return;
        }
        if (!validForm) {
            formRef.current?.validate();
            return;
        }
        onSubmitClick();
    };
    return (React.createElement("div", { className: "c-barcode__infrared" },
        React.createElement(Form, { className: "c-barcode__infrared-form", data: formData, disabled: true, editing: true, locked: true, onChange: onFormChange, onValidate: onFormValidate, ref: formRef },
            React.createElement(Field, { alwaysShowLabel: true, entry: "value", label: props.infraredInputBarcodeExpression, onKeyDown: onInputFieldKeydown, validators: [requiredValidator], width: 12 },
                React.createElement(Input, { autoFocus: true, formatters: props.formatters, inputMode: InputMode.NONE }))),
        React.createElement("div", { className: "c-barcode__content-actions" },
            React.createElement(Button, { enabled: validForm, key: "barcode-button-infrared-submit", onClick: onSubmitClick, theme: ButtonTheme.PRIMARY, value: props.infraredInputSubmitExpression }),
            props.inputActions)));
});
export { InfraredContent, };
//# sourceMappingURL=infrared-content.js.map